import React, { useEffect, useState } from 'react'
import { MotifIcon } from "@ey-xd/motif-react";
import { contentIcSave24px } from "@ey-xd/motif-react/assets/icons";
import Modal from '../../../common/components/Modal/Modal'
import { avoidXSSattackMinimalSpecCharAllowed } from 'utils/security';
import { MotifErrorMessage } from '@ey-xd/motif-react';
import { MotifInput, MotifFormField, MotifLabel } from '@ey-xd/motif-react';

import './AddVunerabilityModal.scss';

const MAX_LENGTH = 100;
const ERROR_MESSAGE = `Vulnerability name should not exceed ${MAX_LENGTH} characters`;
const ERROR_MESSAGE_ONLY_NUMBER = 'Vulnerability name should contain at least one letter.';

const AddVunerabilityModal = ({ visibility, setVisibility, onAdd, errorMsg, vulnerabilityDuplicateErrMsg, setvulnerabilityDuplicateErrMsg}: any) => {
    const [vulnName, setVulnName] = useState('');
    const [error, setError] = useState(false);
    const [errorOnlyNumber, setErrorOnlyNumber] = useState<string | null>(null)
    const handleVulnNameChange = (e: any) => {
        e=avoidXSSattackMinimalSpecCharAllowed(e);
        const value = e.target.value;
        if (value?.length >= MAX_LENGTH) {
          setError(true);
        } else {
          setError(false);
        }
        setVulnName(value);
    };
  // console.log(vulnerabilityDuplicateErrMsg,'vulnerabilityDuplicateErrMsg');
  //  if error message we need to add a logic as below         
  useEffect(() => {
    if (!vulnerabilityDuplicateErrMsg) {
      setErrorOnlyNumber(errorMsg);
      setErrorOnlyNumber("Duplicate Vulnerability Name Found");
      return;
    }
  }, [vulnerabilityDuplicateErrMsg])
    return (
      <Modal
        isAddVulNameModal
        isVisible={visibility}
        setVisible={setVisibility}
        vulnerabilityDuplicateErrMsg={vulnerabilityDuplicateErrMsg}
        setvulnerabilityDuplicateErrMsg={setvulnerabilityDuplicateErrMsg}
        headerContent={
          <div className="saveModalHeader" id="dialog-title">
            <MotifIcon
              src={contentIcSave24px}
              className="saveModalHeader__icon"
            />
            <div>Add new Vulnerability</div>
          </div>
        }
        bodyContent={
          <div className='saveModalContent'>
            <div className='saveModalContent__label'>Saving new Vulnerability</div>
            <div className='saveModalContent__text'>Please provide unique name for vulnerability.</div>
            <div className='saveModalContent__text'>After saving it <b>will be available in Vulnerability’s Library.</b></div>
            <div className='saveModalContent__label'>Vulnerability Name (required)</div>
            <MotifFormField>
              <MotifLabel>ex. Vulnerability Unique Name</MotifLabel>
              <MotifInput onChange={handleVulnNameChange} 
                onKeyUp={() => {
                  if (!vulnerabilityDuplicateErrMsg) {
                    setErrorOnlyNumber(null);
                    setvulnerabilityDuplicateErrMsg(true); // Only clear error if it was previously false
                  }
                }}               
              maxLength={MAX_LENGTH} value={vulnName}/>
              {error &&  <MotifErrorMessage role='alert'> {ERROR_MESSAGE} </MotifErrorMessage> }
              {errorOnlyNumber &&  <MotifErrorMessage role='alert'> {errorOnlyNumber} </MotifErrorMessage> }
            </MotifFormField>
          </div>
        }
        onConfirmClick={()=> {
          if (!/[a-zA-Z]/.test(vulnName)) {
            setErrorOnlyNumber(ERROR_MESSAGE_ONLY_NUMBER);
            return;
          }
          if (/^[\d&\-_:@]+$/.test(vulnName)) {
            setErrorOnlyNumber(ERROR_MESSAGE_ONLY_NUMBER);
            return;
          } else {
            setErrorOnlyNumber(null);
            onAdd(vulnName);
            // setVisibility(true);
            setVulnName('');
            setvulnerabilityDuplicateErrMsg(true)
          }
        }}
      />
    );
}

export default AddVunerabilityModal;